/* eslint-disable */

export default {
  '01': 'First Circuit',
  '02': 'Second Circuit',
  '03': 'Third Circuit',
  '04': 'Fourth Circuit',
  '05': 'Fifth Circuit',
  '06': 'Sixth Circuit',
  '07': 'Seventh Circuit',
  '08': 'Eighth Circuit',
  '09': 'Ninth Circuit',
  '10': 'Tenth Circuit',
  '11': 'Eleventh Circuit',
  "AL": "Alabama",
  "alm": "Alabama Middle",
  "aln": "Alabama Northern",
  "als": "Alabama Southern",
  "AK": "Alaska",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "are": "Arkansas Eastern",
  "arw": "Arkansas Western",
  "CA": "California",
  "cac": "California Central",
  "cae": "California Eastern",
  "can": "California Northern",
  "cas": "California Southern",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District of Columbia",
  "FL": "Florida",
  "flm": "Florida Middle",
  "fln": "Florida Northern",
  "fls": "Florida Southern",
  "GA": "Georgia",
  "gam": "Georgia Middle",
  "gan": "Georgia Northern",
  "gas": "Georgia Southern",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "ilc": "Illinois Central",
  "iln": "Illinois Northern",
  "ils": "Illinois Southern",
  "IN": "Indiana",
  "inn": "Indiana Northern",
  "ins": "Indiana Southern",
  "IA": "Iowa",
  "ian": "Iowa Northern",
  "ias": "Iowa Southern",
  "KS": "Kansas",
  "KY": "Kentucky",
  "kye": "Kentucky Eastern",
  "kyw": "Kentucky Western",
  "LA": "Louisiana",
  "lae": "Louisiana Eastern",
  "lam": "Louisiana Middle",
  "law": "Louisiana Western",
  "ME": "Maine",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "mie": "Michigan Eastern",
  "miw": "Michigan Western",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "msn": "Mississippi Northern",
  "mss": "Mississippi Southern",
  "MO": "Missouri",
  "moe": "Missouri Eastern",
  "mow": "Missouri Western",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "nye": "New York Eastern",
  "nyn": "New York Northern",
  "nys": "New York Southern",
  "nyw": "New York Western",
  "NC": "North Carolina",
  "nce": "North Carolina Eastern",
  "ncm": "North Carolina Middle",
  "ncw": "North Carolina Western",
  "ND": "North Dakota",
  "NMI": "Northern Mariana Islands",
  "OH": "Ohio",
  "ohn": "Ohio Northern",
  "ohs": "Ohio Southern",
  "OK": "Oklahoma",
  "oke": "Oklahoma Eastern",
  "okn": "Oklahoma Northern",
  "okw": "Oklahoma Western",
  "OR": "Oregon",
  "PA": "Pennsylvania",
  "pae": "Pennsylvania Eastern",
  "pam": "Pennsylvania Middle",
  "paw": "Pennsylvania Western",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "tne": "Tennessee Eastern",
  "tnm": "Tennessee Middle",
  "tnw": "Tennessee Western",
  "TX": "Texas",
  "txe": "Texas Eastern",
  "txn": "Texas Northern",
  "txs": "Texas Southern",
  "txw": "Texas Western",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "vae": "Virginia Eastern",
  "vaw": "Virginia Western",
  "WA": "Washington",
  "wae": "Washington Eastern",
  "waw": "Washington Western",
  "WV": "West Virginia",
  "wvn": "West Virginia Northern",
  "wvs": "West Virginia Southern",
  "WI": "Wisconsin",
  "wie": "Wisconsin Eastern",
  "wiw": "Wisconsin Western",
  "WY": "Wyoming"
};



/** WEBPACK FOOTER **
 ** ./src/maps/regionOptionsOfBankruptcySearchFormMap.js
 **/